"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSystemElementConnectorConfigurationFromSpecificElements = exports.createSystemElementConnectorConfigurationFromAllElements = void 0;
const extractors_1 = require("../extractors");
const elements_1 = require("../elements");
const connectors_1 = require("./connectors");
const CURRENT_VERSION = 1;
/**
 * Create configuration for a system element connector using <b>ALL</b> the currently available system elements
 * @param id connector id
 * @param accountId account id (even though system elements are not account-specific, the actual connector configuration
 *      might be saved to a specific account and/or program)
 * @param name connector name
 */
function createSystemElementConnectorConfigurationFromAllElements(id, accountId, name) {
    return createSystemElementConnectorConfigurationFromSpecificElements(id, accountId, name, elements_1.ALL_SYSTEM_ELEMENTS.map(de => de.serialize()));
}
exports.createSystemElementConnectorConfigurationFromAllElements = createSystemElementConnectorConfigurationFromAllElements;
/**
 * Create configuration for a system element connector using a specific set of elements
 * @param id connector id
 * @param accountId account id (even though system elements are not account-specific, the actual connector configuration
 *      might be saved to a specific account and/or program)
 * @param name connector name
 * @param serializedElements set of elements to include in the connector
 */
function createSystemElementConnectorConfigurationFromSpecificElements(id, accountId, name, serializedElements) {
    return {
        version: 1,
        type: connectors_1.ConnectorType.SystemElement,
        id: `${id}-SystemDynamicElements-v${CURRENT_VERSION}`,
        offlineExtractor: {
            type: extractors_1.ExtractorType.Dummy,
            version: 1
        },
        runtimeExtractor: {
            type: extractors_1.ExtractorType.Dummy,
            version: 1
        },
        name,
        accountId,
        elements: serializedElements
    };
}
exports.createSystemElementConnectorConfigurationFromSpecificElements = createSystemElementConnectorConfigurationFromSpecificElements;
//# sourceMappingURL=systemElementConnector.js.map